// extracted by mini-css-extract-plugin
module.exports = {"container":"BottomBanner_container__O4Ui9","title":"BottomBanner_title__i77ru","btn":"BottomBanner_btn__1SCeF"};